<template>
  <UiModalContainer :modal-show="modal" @handleClick="handleModalAction">
    <template v-slot:header>
      <div class="text-primary-gray-900 font-semibold">{{ modalTitle }}</div>
    </template>

    <!-- Markdown editor -->
    <UIMarkdownEditor ref="editor" v-model="markdown" class="py-2" />
    <!-- Need to implement these components in future -->
    <!-- Add to your post section -->
    <!-- <AddToPostSection @image-selected="handleImageSelected" /> -->

    <!-- Selected images preview -->
    <!-- <ImagePreview :images="selectedImages" @remove-image="removeImage" /> -->

    <!-- Labels selection -->
    <UiMultiSelect
      v-model="selectedLabels"
      :options="labelsList"
      title="Labels"
      class="mt-5 w-3/4"
      label="title"
      reduce="id"
      name="labels"
      :already-selected="edit?.labels || []"
      :search-through-api="true"
      @search="filterLabels"
    />
    <template v-slot:footer>
      <div class="w-full flex items-center justify-end gap-3">
        <UIButton button="primary-button-outline" @click="handleModalAction">Cancel</UIButton>
        <UIButton button="primary" @click="submit">Post</UIButton>
      </div>
    </template>
  </UiModalContainer>
</template>

<script>
import UiModalContainer from '@src/components/UiElements/UiModalContainer.vue'
import UIButton from '@src/components/UiElements/UIButton.vue'
import UIMarkdownEditor from '@src/lib/markdown/UIMarkdownEditor.vue'
// Need to implement these components in future
// import AddToPostSection from '@src/components/notice-board/AddToPostSection.vue'
// import ImagePreview from '@src/components/notice-board/ImagePreview.vue'
import UiMultiSelect from '@src/components/UiElements/UiMultiSelect.vue'
import { mapActions } from 'vuex'
import { buildWhereQuery } from '@src/utils/filters'
import FILTER_KEYS from '@src/constants/filter-constants'

export default {
  name: 'CreateEditNoticeBoardPost',
  components: {
    UiModalContainer,
    UIButton,
    UIMarkdownEditor,
    // Need to implement these components in future
    // AddToPostSection,
    // ImagePreview,
    UiMultiSelect,
  },
  props: {
    modal: { type: Boolean, default: false },
    edit: { type: Object, default: () => {} },
  },
  emits: ['toggle'],
  data() {
    return {
      markdown: '',
      selectedImages: [],
      selectedLabels: [],
      labelsList: [],
    }
  },
  computed: {
    modalTitle() {
      return this.edit ? 'Update Post' : 'Create Post'
    },
  },
  created() {
    if (this.edit) this.setPostData()
    this.filterLabels()
  },
  methods: {
    filterLabels(query = '') {
      const payload = {
        where: buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query),
      }
      this.getPostLabels(payload).then((res) => {
        this.labelsList = res?.data?.records || []
      })
    },
    setPostData() {
      this.markdown = this.edit.description
    },
    handleModalAction() {
      this.$emit('toggle')
    },

    handleImageSelected(imageData) {
      this.selectedImages.push(imageData)
    },

    removeImage(index) {
      this.selectedImages.splice(index, 1)
    },

    submit() {
      const markdownContent = this.$refs.editor.getMarkdown()
      const payload = {
        post: {
          description: markdownContent,
          label_ids: this.selectedLabels,
        },
      }
      if (this.edit) payload.id = this.edit.id

      this.createPost(payload).then(() => {
        this.$emit('toggle', 'fetch')
      })
    },
    ...mapActions('noticeboard', ['createPost', 'getPostLabels']),
  },
}
</script>

<style scoped></style>
